import React from 'react'
import { Image } from 'semantic-ui-react'
import logosImageDark from 'assets/images/qr_redirect/qr_redirect_logos_dark.png'
import i18next from 'i18next'

export default function AndroidButton({
  handleAndroidButtonClick,
}: {
  readonly handleAndroidButtonClick: () => void
}) {
  return (
    <button
      onClick={handleAndroidButtonClick}
      className="border-0 bg-transparent pb-0 pl-0 pr-0 pt-5"
    >
      <div className="android-btn__container [container-type:inline-size]">
        <div className="android-btn__border mx-auto w-1/2 [aspect-ratio:10/3] bg-neutral-400 [border-radius:1.5cqw] [container-type:inline-size] [padding:0.3%_0.3%]">
          <div className="android-btn__inner flex h-full w-full flex-row bg-black [border-radius:inherit]">
            <div className="android-btn__img-container flex w-[60%] flex-col items-center justify-center">
              <Image
                size="large"
                src={logosImageDark}
                style={{
                  width: '100%',
                }}
                alt={i18next.t('logo')}
              />
            </div>

            <div className="android-btn__text-container flex w-[40%] flex-col items-start justify-center text-left text-brand-white">
              <div className="android-btn__text-top m-0 whitespace-nowrap pb-[5%] text-[clamp(10px,6cqw,26px)] leading-[1.1] text-brand-white">
                {i18next.t('get_for_free')}
              </div>
              <div className="android-btn__text-bottom m-0 whitespace-nowrap text-[clamp(12px,8cqw,30px)] font-bold leading-[1.1] text-brand-white">
                {i18next.t('download')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  )
}
